import React from 'react';
import { Form } from '@crisellevaldez/speculo-ui';

interface QuestionLabelProps {
  children: React.ReactNode;
  required?: boolean;
}

export const QuestionLabel: React.FC<QuestionLabelProps> = ({ children, required = true }) => {
  return (
    <Form.Label className="text-lg font-semibold mb-1" required={required}>
      {children}
    </Form.Label>
  );
};
